class StateConstants {
    static ADDRESS_STATE = "address"
    static AUTOSUGGEST_QUOTA_LIMIT_REACHED = "quotaLimitReached"
    static SUGGESTIONS_STATE = "suggestions"
    static SHOW_SUGGESTIONS = "showSuggestions"
    static RELATIVE_CONDITION = "rc"
    static REMOVED_HOMES = "removedHomes"
    static ADVANCED_OPTIONS = "advancedOptions"
    static SHOULD_UPDATE_VALUATION = "shouldUpdateValuation"
    static IS_LOADING = "isLoading"
    static VALUATION_LOADING = "valuationLoading"
    static STATE_UPDATE_COUNT = "stateUpdateCount"
    static ERROR = "error"
    static IS_GOOGLE_BOT = "isGoogleBot"
    static SHOW_TIME_SERIES = "showTimeSeries"
    static IS_MOBILE = "isMobile"

    static IS_LOGGED_IN = "isLoggedIn"
    static SHOW_ACCOUNT_PANEL = "showAccountPanel"
    static CURRENT_PAGE_STATE = "currentPageState"

    static COMPARABLE_HOMES_STATE = "comparableHomes"
    static VALUATION_STATE = "valuation"
    static SAVED_VALUATIONS = "savedValuations"

    static MAP_MARKER_HOVER = "mapMarkerHover"
    static MAP_MARKER_CLICK = "mapMarkerClick"

    static VALUATION_COMPLETE_STATE = "valuationComplete"

    static AREA_SEARCH_STATE = "areaSearch"
    static AREA_SUGGESTIONS_STATE = "areaSuggestions"
    static SHOW_AREA_SUGGESTIONS = "showAreaSuggestions"
    static AREA_STATE = "area"

    static VALUATION_USAGE = "valuationUsage"

    static IS_PREMIUM = "isPremium"
    static SHOW_PLAN_MODAL = "showPlanModal"
    static SHOW_LOGIN_MODAL = "showLoginModal"
    static PENDING_PAYMENT_INTENT_ID = "pendingPaymentIntentId"
    static ACCOUNT_TYPE = "accountType"
    static USER_FEATURES = "userFeatures"
}

export default StateConstants